import { render, staticRenderFns } from "./TakeAttendance.vue?vue&type=template&id=4eee98a7&scoped=true&"
import script from "./TakeAttendance.vue?vue&type=script&lang=js&"
export * from "./TakeAttendance.vue?vue&type=script&lang=js&"
import style0 from "./TakeAttendance.vue?vue&type=style&index=0&id=4eee98a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eee98a7",
  null
  
)

export default component.exports